import { LogInSchoolID, LogInUserID, BaseUrl } from "../../../JS/Common";
import { ApiCmnHeadersPostCall } from "../../../JS/Connector";

export const importGoogleDeviceAPI = async (data, NewUpdate) => {
  try {
    var formdata = new FormData();
    formdata.append("uuid", LogInUserID);
    formdata.append("schoolId", LogInSchoolID);
    formdata.append("code", data?.code);
    formdata.append("addUpdateFlag", NewUpdate == "Add" ? 0 : 1);

    try {
      const response = await ApiCmnHeadersPostCall(`/google/initiate-data-fetch`, formdata, false, true);
      return response;
    } catch (error) {
      throw error;
    }
  } catch (error) {
    throw error;
  }
};

export const GetGoogleAdminData = async (accessToken, url) => {
  try {
    var requestOptions = {
      method: "GET",
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
      redirect: "follow",
    };
    const response = await fetch(url, requestOptions);
    const statusCode = response.status;
    const result = await response.json();
    return { statusCode, result };
  } catch (error) {
    throw error;
  }
};
export const PostErrorCall = async (msg, FunctionName) => {
  try {
    const raw = JSON.stringify({
      msg: msg,
      function: FunctionName,
      userid: LogInUserID,
      schoolid: LogInSchoolID,
    });

    try {
      const response = await ApiCmnHeadersPostCall(`/errors/frontend/save`, raw, true);
      const result = await response.text();
      return result;
    } catch (error) {
      throw error;
    }
  } catch (error) {
    throw error;
  }
};
